import { gql } from "@apollo/client";
import ReactableFields from "../../../lib/graphql/fragments/ReactableFields";

export default gql`
  mutation RemoveReaction($input: RemoveReactionInput!) {
    removeReaction(input: $input) {
      ... on AssetDiscussionComment {
        _id
        ...ReactableFields
      }
      ... on AssetDiscussionCommentReply {
        _id
        ...ReactableFields
      }
    }
  }

  ${ReactableFields}
`;
